import { render, staticRenderFns } from "./SImage.vue?vue&type=template&id=7a89301e&"
import script from "./SImage.vue?vue&type=script&lang=js&"
export * from "./SImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports